// Module
var code = "<div class=\"tc-logo\">\n  <img :src=\"src\" alt=\"Taslonic\" title=\"Taslonic\" :width=\"width\" :height=\"height\" />\n</div>\n";
// Exports
export default code;